import type { SubmissionStatus } from '@/types/api/submission-status';

const CONFIG: Record<SubmissionStatus, { label: string; className: string }> = {
  pending: {
    label: 'Pendente',
    className: 'bg-secondary/10 text-secondary-dark border border-secondary/25',
  },
  handled: {
    label: 'Resolvido',
    className: 'bg-tertiary/10 text-tertiary border border-tertiary/25',
  },
  dismissed: {
    label: 'Arquivado',
    className: 'bg-background text-on-surface-light border border-line',
  },
};

export function StatusBadge({ status }: { status: SubmissionStatus }) {
  const { label, className } = CONFIG[status] ?? {
    label: status,
    className: 'bg-background text-on-surface-light border border-line',
  };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${className}`}
    >
      {label}
    </span>
  );
}
